import { Box, Stack } from "@mui/material";
import { HighLevelKpiCard } from "./HighLevelKpiCard";

export default function HighLevelKpis() {
  return (
    <Box>
      <Stack spacing={2}>
        <HighLevelKpiCard
          title="FTD"
          value="1,888"
          total="2,501"
          rr="86.7%"
          rrColor="warning"
          progress={75}
          predicted="2,345"
          extraInfo="To meet the periodic goal, an additional $126,557 profit must be generated by the end of the period. This requires an average daily profit of $14,062."
        />

        <HighLevelKpiCard
          title="Profit"
          value="$90,311"
          total="$372,496"
          rr="55.9%"
          rrColor="error"
          progress={40}
          predicted="$208,410"
          extraInfo="To meet the periodic goal, an additional $126,557 profit must be generated by the end of the period. This requires an average daily profit of $14,062."
        />

        <HighLevelKpiCard
          title="NRPU"
          value="$262"
          total="$260"
          rr="105.6%"
          rrColor="success"
          progress={100}
          predicted="$260"
          extraInfo="To meet the periodic goal, an additional $126,557 profit must be generated by the end of the period. This requires an average daily profit of $14,062."
        />
      </Stack>
    </Box>
  );
}
